var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0094 2.00004L12 2C11.7249 2 11.4758 2.11106 11.295 2.29078L11.2928 2.29301L8.29378 5.29301C7.90332 5.6836 7.90342 6.31677 8.29401 6.70722C8.6846 7.09768 9.31777 7.09758 9.70822 6.70699L11 5.41478V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V5.41421L14.2929 6.70711C14.6834 7.09763 15.3166 7.09763 15.7071 6.70711C16.0976 6.31658 16.0976 5.68342 15.7071 5.29289L12.7071 2.29289C12.5282 2.11399 12.2818 2.00256 12.0094 2.00004Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 10.3427 4.34272 9 6 9H8C8.55228 9 9 9.44771 9 10C9 10.5523 8.55228 11 8 11H6C5.44728 11 5 11.4473 5 12V19C5 19.5527 5.44728 20 6 20H18C18.5527 20 19 19.5527 19 19V12C19 11.4473 18.5527 11 18 11H16C15.4477 11 15 10.5523 15 10C15 9.44771 15.4477 9 16 9H18C19.6573 9 21 10.3427 21 12V19C21 20.6573 19.6573 22 18 22H6C4.34272 22 3 20.6573 3 19V12Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.a2ad67b81284ae26f4091ad910a90009.svg";
export { ForwardRef as ReactComponent };